/**
 *
 *
 * 根更新state mutation
 *
*/

export default {
  /**
   *
   * @params key 更是state的key value 更新key的值
   * 更新state的数据
  */
  updateStateData: (state, params) => {
    const { key, value } = params
    state[key] = value
  },
   /**
   *
   * @params key 更新state的key
   * @params value 更新key的值
   * 更新根state的数据
  */
  updateRootStateData: (state, params) => {
    const { key, value } = params
    state[key] = value
  },
}